import o from "process";
import { inIframe as s } from "../deviceUtils.js";
const c = o.env.NODE_ENV === "production" || location.protocol.startsWith("https"), r = o.env.NODE_ENV === "test", i = s(), p = (t) => !r && console.debug(t);
export {
  p as debug,
  i as isInIframe,
  c as isProd,
  r as isTest
};
//# sourceMappingURL=initConfig.js.map
